import { Component, OnInit } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginModel } from './login-model';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../apimethods/api-method';
import { AuthService } from './../auth.service';
import { filter } from 'rxjs/operators';
import { DataAccess } from '../common/dataaccess.service';

declare var $;

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
/** login component*/
export class LoginComponent implements OnInit {
  modelItem: LoginModel = new LoginModel();
  SQList: JSON; MfVendorList: JSON;
  LoginIDReset: string = '';
  SQAnswer: string = '';
  LoginID: string = '';
  RegisterEmail: string = '';
  Password: string = '';
  message: string = '';
  aResultL: any;
  IsLoginView: boolean = true;
  isShownLogin: boolean = true;
  isShownReset: boolean = false;
  ssoLogin: boolean = false;
  directLogintype: string = ''; _userId: string = ''; manuflow: string = '';
  LoginMode = 'Default'; pubLogo = '';
  currentYear: number = new Date().getFullYear();
  constructor(private router: Router, private route: ActivatedRoute, private location: LocationStrategy,
    private authService: AuthService, private dataAccess: DataAccess) {
    //, private ngRedux: NgRedux<InitialState>
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
    this.loadGeneralmethod();
  }

  ngOnInit() {
    localStorage.clear();
    ApiMethod.getBaseUrl();

    this.route.queryParamMap.subscribe(params => {
      if (params.get("type") != null) {
        localStorage.LoginType = params.get("type");
        if (params.get("type") == 'logoff') {
          this.ssoLogin = false;
        }
        else if (params.get("type") == 'aps') {
          if (params.get("jrnl") != null) {
            localStorage.JrnlFil = params.get("jrnl");
          }
          if (params.get("articleId") != null) {
            localStorage.artId = params.get("articleId");
          }
          $("#LoadingImage").show();
          this.directLogintype = params.get("type");
        }
        else if (params.get("type") == 'proofing') {
          $("#LoadingImage").show();
          this.directLogintype = params.get("type");
          if (params.get("id") != null) {
            this._userId = params.get("id");
          }
        }
        else if (params.get("type") == 'apsauthorproof') {
          this.LoginMode = params.get("type");
          localStorage.LoginType = this.LoginMode;
          this.pubLogo = this.LoginMode.replace('authorproof', '');
        }
        else {
          this.directLogintype = params.get("type");
        }
      }
    });

    this.authService.initializeAuth();
  }

  ngAfterViewInit() {
    this.LoadSecurityQuestionList();

  }

  loadGeneralmethod() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <LoginModel>data["LoginPage"];

        if (this.directLogintype == 'aps') {
          this.LoginValidation(this.modelItem.LoginId, this.modelItem.Password);
        }
        else if (this.directLogintype == 'proofing') {
          this.LoginValidation('', '', this._userId);
        }
        if (this.directLogintype == 'manuflow') {
          this.LoadManuflowVendorList();
        }
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  toggleShow(aitem) {
    this.LoginIDReset = ''; $('#ddlSQList').val(0).change(); this.SQAnswer = ''; this.RegisterEmail = '';
    this.LoadSecurityQuestionList();
    if (aitem == 'Login') {
      this.isShownReset = false;
      this.isShownLogin = true;
      $('#divLogin').show(); $('#divReset').hide();
    }
    else if (aitem == 'Reset') {
      this.isShownReset = true;
      this.isShownLogin = false;
      $('#divLogin').hide(); $('#divReset').show();
    }
  }

  // Load SQList List
  LoadSecurityQuestionList() {
    if (this.modelItem.SQSListAPI != '') {
      ApiMethod.getMethod(this.modelItem.SQSListAPI).subscribe(
        result => {
          this.SQList = JSON.parse(JSON.stringify(result.aitemList));
        }, error => {
          console.log(error);
        });
    }
  }

  // Load Manuflow Vendor List
  LoadManuflowVendorList() {
    if (this.modelItem.Mfvendorlist != '') {
      ApiMethod.getMethod(this.modelItem.Mfvendorlist).subscribe(
        result => {
          console.log(result);
          this.MfVendorList = JSON.parse(JSON.stringify(result.aitemList));
        }, error => {
          console.log(error);
        });
    }
  }

  //AuthenticateLogin Function
  Authenticate(): void {
    let userReg = new RegExp(this.modelItem.UserNameFormat);
    let pwdReg = new RegExp(this.modelItem.PasswordFormat);
    if (this.LoginID == '' || this.Password == '') {
      ngswal("Warning !", 'Please enter User Name Or Password', "warning");
    }
    else if (!userReg.test(this.LoginID)) {
      ngswal("Warning !", this.modelItem.UserNameMsg, "warning");
    }
    else if (!pwdReg.test(this.Password)) {
      ngswal("Warning !", this.modelItem.PasswordMsg, "warning");
    }
    else {
      $("#LoadingImage").show();
      this.LoginValidation(this.LoginID, this.Password);
    }
  }


  LoginValidation(loginID, password, userId = '0'): void {
    var userItem = {
      LoginID: loginID,
      Password: password,
      UserID: userId
    };
    ApiMethod.postMethod(this.modelItem.AuthenticateAPI, userItem).subscribe(
      resonse => {
        console.log(resonse);
        if (typeof resonse.aValidateL === "undefined") {
          this.message = resonse.Message;
          $("#LoadingImage").hide();
        }
        else {
          if (resonse.aValidateL == true) { // Validate success 
            let aUserList = resonse.aitemList; let aMenuList = resonse.aMenuAccessList; let athemesList = resonse.athemesList;
            let roleList = resonse.aroleList;
            $("#LoadingImage").hide();
            localStorage.aPubID = aUserList[0].PublisherID; localStorage.aLoginID = aUserList[0].UserID; localStorage.aLoginName = aUserList[0].LoginName;
            localStorage.UserThemes = aUserList[0].Themes; localStorage.athemesList = JSON.stringify(athemesList); localStorage.aImgLogo = (aUserList[0].Image == null ? '../../../assets/Images/userLogo.jpg' : aUserList[0].Image);
            localStorage.aMenuList = JSON.stringify(aMenuList);
            localStorage.roleList = JSON.stringify(roleList);
            localStorage.roleId = aUserList[0].RoleID;
            localStorage.indexPage = aUserList[0].DashboardLink;
            //Redirect role based login
            localStorage.hideTopIcon = (aUserList[0].IsVisibleHeaderIcon == false);
            localStorage.xflow = aUserList[0].ExpressFlow;
            localStorage.multiPublist = aUserList[0].PubliserList;

            if (localStorage.LoginType == 'apsauthorproof') {
              localStorage.artNo = password;
            }
            let dashboardLink = aUserList[0].DashboardLink;
            if (this.directLogintype == 'proofing') {
              if (dashboardLink.toString().indexOf('ept') == -1) {
                ngswal("Warning !", "Invalid Proofing Url !", "warning");
              }
              else {
                this.router.navigate([dashboardLink]);
              }
            }
            else {
              this.router.navigate([dashboardLink]);
            }
          }
          else { // Validate failure 
            $("#LoadingImage").hide();
            this.message = resonse.message;
          }
        }
      },
      error => {
        console.log(error);
        $("#LoadingImage").hide();
        try {
          this.message = error.error.Message;
        } catch (e) {
          this.message = error.message;
        }
      }
    );
  }

  ResetSelection(): void {
    if ($('#ddlResetOption').val() == "Email") {
      $('#divEmail').show();
      $('#divSQ').hide();
    }
    else {
      $('#divSQ').show();
      $('#divEmail').hide();
    }
  }

  //Reset Password functions
  ResetPassword(): void {
    if (this.LoginIDReset == '') {
      ngswal("Warning !", "Enter User Name for Reset Password !", "warning");
      $("#LoadingImage").hide();
    }
    else if (this.RegisterEmail == '' && $('#ddlResetOption').val() == "Email") {
      ngswal("Warning !", "Enter Registered Email !", "warning");
      $("#LoadingImage").hide();
    }
    else if ($('#ddlSQList').val() == 0 && $('#ddlResetOption').val() == "SecurityQuestion") {
      ngswal("Warning !", "Select Security Question !", "warning");
      $("#LoadingImage").hide();
    }
    else if (this.SQAnswer == '' && $('#ddlResetOption').val() == "SecurityQuestion") {
      ngswal("Warning !", "Enter Security Question Answer !", "warning");
      $("#LoadingImage").hide();
    }
    else {
      $("#LoadingImage").show();
      var userItem = {
        LoginID: this.LoginIDReset,
        EmailID: this.RegisterEmail,
        SecurityQuestionID: $('#ddlSQList').val(),
        QuestionAnswer: this.SQAnswer,
        DefaultPage: $('base')[0].href,
        UpdateMode: $('#ddlResetOption').val()
      };
      ApiMethod.postMethod(this.modelItem.ForgotPasswordAPI, userItem).subscribe(
        result => {
          $("#LoadingImage").hide();
          if (result.Message != null)
            ngswal("Reset Password", result.Message, "warning");
          else
            ngswal("Reset Password", result, "info");

        }, error => {
          $("#LoadingImage").hide();
          try {
            ngswal("Warning !", error.error.Message, "warning");
          } catch (e) {
            ngswal("Warning !", error.Message, "warning");
          }
        });
    }
  }

  updateType() {
    var passwordType = $('#password').attr("type");

    if (passwordType == "password") {
      $("#password").attr("type", "text");
      $("#password-addon").html("<i class='far fa-eye'></i>");
    }
    else if (passwordType == "text") {
      $("#password").attr("type", "password");
      $("#password-addon").html("<i class='far fa-eye-slash'></i>");
    }
  }

  loginDisplay = false;
  loginStatus = '';

  //SSO Authenticate
  SSOAuthenticate(): void {
    this.ssoLogin = true;
    let account = this.authService.getAccountDetails();
    if (account == null) {
      this.authService.logIn();
    }
  }

  SSOlogout() {
    this.authService.logOut();
  }

  ngAfterViewChecked(): void {
    if (this.ssoLogin) {
      let account = this.authService.getAccountDetails();
      if (account != null) {
        this.SsoLoginValidate(account.userName, account.name);
      }
    }
  }

  SsoLoginValidate(userName, name) {
    $("#LoadingImage").show();
    var userItem = {
      LoginID: userName,
      LoginName: name
    };
    ApiMethod.postMethod(this.modelItem.SSOAuthenticateAPI, userItem).subscribe(
      result => {
        $("#LoadingImage").hide();
        let userDataItem = result.userData;
        if (userItem != null)
          this.LoginValidation(userDataItem.loginName, userDataItem.password);

      }, error => {
        $("#LoadingImage").hide();
        try {
          ngswal("Warning !", error.error.Message, "warning");
        } catch (e) {
          ngswal("Warning !", error.Message, "warning");
        }
      });
  }
}


